// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';


import UsersList from '../../UsersList';
import UsersHeader from '../../UsersHeader';
import CardContent from '../../CardContent';
import UsersFilters from '../../UsersFilters';


// type UserViewPropTypes = {

// };

const UserView = () => (
  <Fragment>
    <UsersHeader />
    <CardContent>
      <UsersFilters />
      <UsersList />
    </CardContent>
  </Fragment>
);

export default connect(
  undefined,
  undefined,
)(withRouter(UserView));



// WEBPACK FOOTER //
// ./src/scripts/components/views/BackendUsersView/index.jsx